import { useEffect, useRef } from "react";
import { useAppState, useAppDispatch } from "context";
import { setCreativeViewSize } from 'context/actions';

import "./Overlay.scss";

declare global {
    interface Window {
        kervFrame: any,
        kervEmbedApp: any,
        kervPlayer: any,
    }
}

type OverlayProps = {
    banner?: {
        active?: boolean,
        size?: {
          width: number,
          height: number,
        }
    },
    payload: any,
    
}

const Overlay = (props: OverlayProps) => {
    const dispatch = useAppDispatch();
    const { banner = {}, payload ={}} = props;
    const creativeWrapper = useRef<HTMLDivElement>(null);
    const crvWrapperID = 'overlay-slot';
    const cssBanner = banner.active ? 'banner' : 'not-banner';

    const runScripts = async () => {
        return window.kervFrame.loadCreative({
            slotID: `#${crvWrapperID}`,
            payload,
            fitContainer: true,
            video: {
                autoPlay: true
            },
            center: true,
            isPreview: true,
            banner: banner?.active,
            bannerSize: {
                width: banner?.size?.width,
                height: banner?.size?.height,
            }
        })
    };

    // RUN SCRIPTS
    useEffect(() => {
        runScripts()
        .then((data) => {
            dispatch(setCreativeViewSize({loaded:true}))
        })
        .catch((data) => {
            console.debug('error', data);
            dispatch(setCreativeViewSize({loaded:false}))
        });

        // clean player and overlay
        return () => {
            // clearTimeout(timer);
            if (window.kervFrame) {
                window.kervFrame.dispose();
                dispatch(setCreativeViewSize({loaded:false}))
            }
        }

    }, [banner.active, banner.size, payload.id]);


    return (
        <div
            id={crvWrapperID}
            className={`creative-overlay ${cssBanner}`}
            ref={creativeWrapper}
        />
    );
};

export default Overlay;
